import { useEffect, useState } from 'react';

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem('what-mobile:theme') === 'dark'; } catch (_) { return false; }
  });
  useEffect(() => {
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    try { localStorage.setItem('what-mobile:theme', dark ? 'dark' : 'light'); } catch (_) {}
  }, [dark]);
  return <button className="theme-toggle" onClick={() => setDark(!dark)} aria-pressed={dark}>{dark ? '☀ Tema chiaro' : '☾ Tema scuro'}</button>;
}
